import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase} from '@/components/a-interfaz/a-controlador';

export class ControladorInterfaz extends ControladorBase
{
    constructor()
    {
        super();
        this.Vista.Titulo = 'Reputacion ML';
        this.Vista.Opciones.push()
    }

}

export const Controlador = new ControladorInterfaz();


